import React, { FC, ReactNode, ReactText, useRef } from "react";
import { Box, Flex, IconButton, Link, Popover, PopoverContent, PopoverTrigger, Text, Button, Stack, Collapse, Icon, useBreakpointValue, useColorModeValue, useDisclosure, Container, useColorMode, Menu, MenuButton, MenuList, Center, Avatar, MenuDivider, MenuItem, Spacer, Drawer, DrawerOverlay, DrawerContent, DrawerCloseButton, DrawerHeader, DrawerBody, DrawerFooter, SimpleGrid, Tag, FlexProps, Grid, GridItem } from "@chakra-ui/react";

import { FiUser, FiSettings, FiFileText, FiAperture, FiLogOut } from 'react-icons/fi';
import { useNavigate } from "react-router-dom";
import { IconType } from "react-icons";
import AppConsts from "../../libs/appconst";

type LayoutProps = {
    children: ReactNode
};

interface NavItemProps extends FlexProps {
    icon: IconType;
    children: ReactText;
}

const NavItem = ({ icon, children, ...rest }: NavItemProps) => {
    return (
        <Link style={{ textDecoration: 'none' }} _focus={{ boxShadow: 'none' }}>
            <Flex
                align="center"
                px="4"
                py="3"
                mr={10}
                fontSize={'sm'}
                role="group"
                cursor="pointer"
                borderBottom="1px"
                borderColor="gray.200"
                _hover={{
                    color: 'teal.700'
                }}
                {...rest}>
                {icon && (
                    <Icon
                        mr="4"
                        fontSize="16"
                        _groupHover={{
                            color: 'teal.700',
                        }}
                        as={icon}
                    />
                )}
                {children}
            </Flex>
        </Link>
    );
};

const LayoutAccount: FC<LayoutProps> = ({ children }) => {
    const navigate = useNavigate();

    return (
        <Grid templateColumns={{ base: 'repeat(1, 1fr)', md: 'repeat(4, 1fr)' }} gap={5}>
            <GridItem>
                <Box
                    display={{ base: 'none', md: 'block' }}
                >
                    <NavItem icon={FiUser} onClick={() => { navigate("/profile") }}>Profile</NavItem>
                    <NavItem icon={FiFileText} onClick={() => { navigate("/billing") }}>Billing</NavItem>
                    <NavItem icon={FiAperture} onClick={() => { window.open(AppConsts.UrlSupportTeam) }}>Support</NavItem>
                    <NavItem icon={FiLogOut} onClick={() => { navigate("/logout") }}>Log Out</NavItem>
                </Box>
            </GridItem>
            <GridItem colSpan={3}>
                <Box>
                    {children}
                </Box>
            </GridItem>
        </Grid>
    );
};

export default LayoutAccount;